import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { CommonService } from '../../services/common.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-doc',
  templateUrl: './doc.component.html',
  styleUrls: ['./doc.component.css']
})
export class DocComponent implements OnInit {

  @Input() chantier;
  @Input() edit: Boolean;
  @Input() hidetitle: Boolean;

  factauto = {};
  avoirAuto = {};
  selected = [];
  dataArticle = [];
  listChantier = [];
  listeAgence = [];
  listeSite = [];
  isEmpty: Boolean = false;
  renderTable: Boolean = true;
  condition1: Boolean = false;
  condition2: Boolean = false;
  condition3: Boolean = false;
  default = 0;
  nbdigit;
  classPresta: String = 'detailfact ';
  adresseAchat: Boolean = false;
  devise;
  pays = '';
  focusIndex = 0;
  listDocument = [];
  deleteElm = [];
  error = '';
  typeDocuments = [];

  @ViewChild('msg') msg;


  constructor(protected common: CommonService, private modalService: BsModalService) { }

  ngOnInit() {
    this.chantier['listDoc'] = this.chantier['listDoc'] || [];
  }

  valide() {
    this.saveDoc();
  }

  getTypeDoc() {
    const param = {
      'servlet': 'DBGestionTypeDocSociete',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 2
        }
      }
    };

    return this.common.post('', { param: param }).then(datas => {
      this.typeDocuments = datas.data;
    });
  }


  getListDoc() {
    const param = {
      'servlet': 'DBGestionDocClient',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 4
        },
        'CLEF_CLIENT': {
          'typeParam': 'int',
          'valeur': this.chantier['id']
        },
      }
    };

    return this.common.post('', { param: param }).then(datas => {
      $('#empty').trigger('click');
      this.listDocument = datas.data;
    });
  }

  openDoc(row) {
    row['clefObjetParent'] = this.chantier ? this.chantier['id'] : 0;
    row.nomclass = 'FileObject';
    const param = {
      'servlet': 'DBGestionDocChantier',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'pathImpression': 'Recylog/tmp/',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 1
        },
        'ID_DOC_CHANTIER': {
          'typeParam': 'int',
          'valeur': row.id
        }
      }
    };

    this.common.post('', { param: param }).then(datas => {
      this.common.openFile(datas.data[0]);
    });
  }

  onActivate(event) {
    if (event.type === 'dblclick') {
      if (event.row.id !== 0) {
        this.openDoc(event.row);
      }
    }
  }

  saveDoc() {
    const prom = [];
    if (this.deleteElm.length) {
      this.deleteElm.forEach(elt => {
        const fct = this.deleteDoc(elt);
        prom.push(fct);
      });
    }
    
    const add = this.listDocument.filter(elt => !elt.id);
    if (add.length) {
      add.forEach(elt => {
        elt.id = 0;
        if(elt['nomFichier']) {   
            const fct = this.addDoc(elt);
            prom.push(fct);
        }
      });
    }

    Promise.all(prom).then(data => {
      if (data.length) {
        // this.hide();
      }

    }).catch(error => {
      this.common.closeModal();
      console.log(error);
    });
  }

  addDoc(doc) {
    doc['clefObjetParent'] = this.chantier ? this.chantier['id'] : 0;
    doc.nomclass = 'FileObject';
    const param = {
      'servlet': 'DBGestionDocClient',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 1
        },
        'DOCUMENT': doc
      }
    };
    return this.common.post('', { param: param }).then(data => {
      if (data.message) {
        return Promise.reject(data.message);
      } else {
        return data;
      }
    });
  }

  deleteDoc(doc) {
    doc['clefObjetParent'] = this.chantier ? this.chantier['id'] : 0;
    doc.nomclass = 'FileObject';
    const param = {
      'servlet': 'DBGestionDocClient',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 2
        },
        'DOCUMENT': doc
      }
    };
    return this.common.post('', { param: param }).then(data => {
      if (data.message) {
        return Promise.reject(data.message);
      } else {
        return data;
      }
    });
  }

  addLigne() {
    this.chantier['listDoc'] = this.chantier['listDoc'] || [];
    this.chantier['listDoc'].push({ id: 0 });
    this.chantier['listDoc'] = [...this.chantier['listDoc']];
    this.setFileObject();
  }

  deleteLigne(row) {
    if (row.id) {
      this.deleteElm.push(row);
      this.deleteElm = [...this.deleteElm];
    }
    const temp = this.chantier['listDoc'].filter(elt => elt !== row);
    this.chantier['listDoc'] = temp;
    this.setFileObject();
  }

  setFileObject() {
    this.chantier['listDoc'].forEach(doc => {
      doc['clefObjetParent'] = this.chantier ? this.chantier['id'] : 0;
      doc.nomclass = 'FileObject';
    })
  }

  getNameFile(event, item, index) {
    const file = event.target.files[0];
    if (file.name && file.name.includes('.pdf')) {
      item.nomFichierOriginal = file.name;
      item.nomFichier = file.name;

      const fileReader = new FileReader();
      const ctrl = this;
      fileReader.onload = function () {
        const base64 = (<string>fileReader.result).split(',');
        item.contentBase64 = base64[1];
      };
      fileReader.readAsDataURL(file);
    } else {
      this.error = 'Veuillez sélectionner un fichier PDF.';
      this.common.openModal(this.modalService, this.msg);
      this.deleteLigne(item);
    }
  }

}
